module.exports = __webpack_public_path__ + "img/widget.6400f936.svg";